
import { Card, Button, Space, Typography, Alert, Modal, List, Divider } from 'antd';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import BookingStateHook from '@/hooks/useBookingState';
import { openPaymentWindow } from '@/utils/paymentWindow';

export default function PaymentOptions() {
  const intl = useIntl();
  const { propcode } = useParams<{ propcode: string }>()
  const navigate = useNavigate()

  const paymentData = useSelector((state: any) => state.paymentBeam);
  const { createdLink } = paymentData;

  const [popupBlocked, setPopupBlocked] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const onPaymentGateway = () => {
    if (!createdLink?.url) return;

    const opened = openPaymentWindow(createdLink.url);
    setPopupBlocked(!opened);
  }

  const onContactAccounting = () => {
    setContactModalOpen(true);
  }
  const onBack = () => {
    navigate(-1)
  }


  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>

      <Card title={intl.formatMessage({ id: 'pay.options.title' }, { defaultMessage: 'Choose your payment method' })} style={{ borderRadius: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          {/* <p>หน้านี้ต้องรับ param query string เพื่อดึงข้อมูลของ booking ที่ทำการจอง เพื่อเอา payment link ไปใช้งานต่อได้</p>*/}
          <Button type="primary" block onClick={onPaymentGateway}>Pay by beam payment</Button>
          <Button block onClick={onContactAccounting}> Manual transfer / Contact accounting</Button>
          <Button block onClick={onBack}>Back</Button>
          {popupBlocked && (
            <Alert
              title={intl.formatMessage({ id: 'booking.paymentPopupBlocked.title' })}
              description={intl.formatMessage({ id: 'booking.paymentPopupBlocked.description' })}
              type="warning"
              showIcon
              style={{ marginTop: 8, textAlign: 'left' }}
            />
          )}
        </Space>
      </Card>

      <Modal
        title="Contact Accounting"
        open={contactModalOpen}
        width={450}
        onOk={() => setContactModalOpen(false)}
        onCancel={() => setContactModalOpen(false)}
      >
        Please contact at email:xxxx@mail.com , Tel.1234567890
      </Modal>
    </Space>
  );
}
